import React from 'react'
import {localestr,typeToText,load} from '../utils.js'

export default function Docum({data,setData,msg}){
    let doc_cap=' '+typeToText(data.doc_type)+' №'+data.id
    let doc_str=doc_cap
    if(data.date) doc_str+=' ('+new Date(data.date).toLocaleString()+')'
    if(data.amount) doc_str+='  '+data.amount

    //tabNew('repObjEntries',localestr('Проводки')+' '+itemToText(item),{object:item},true)
    function open_doc(d){
        if (!d) load('action='+data.doc_type+'&data='+data.id,open_doc)
        else if (d) {
            const status=d.status
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            setData(data.doc_type+'_edit',doc_cap,{...d.data,table:d.table})
        }
    }


    return(
        <div style={{margin:'2px 0',display:'inherit',textDecoration:'underline',color:'blue',cursor:'pointer'}} onClick={()=>open_doc()}>
        {localestr('Введено на підставі')}{doc_str}
        </div>
    )

}

//export default Docum